import axios from '@axios'
import store from "@/store"

export default {
  namespaced: true,
  state: {
    items: [],
    progress: 0,
    error: '',
    url: '',
    isCreatedFile: false
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getProgress(state) {
      return state.progress
    },
    getError(state) {
      return state.error
    },
    getUrl(state) {
      return state.url
    },
    getSelectedItems(state) {
      return state.items.map(facial_recognition => ({
        value: facial_recognition.id,
        label: facial_recognition.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/facial_recognition', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/facial_recognition', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/facial_recognition/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/facial_recognition/${id}`)

      return data
    },
    resetProgress({ state }) {
      state.progress = 0
    },
    setExportFacialRecognition({ state, commit, dispatch }, jobId) {
      const notification = {
        id: `facial-recognition-export-${jobId}`,
        progress: 0,
        completed: false,
        view: 'facial-recognition',
        url: '',
        title: 'Reporte de reconocimiento facial',
        body: 'Descargando...',
        error: false
      }
      store.dispatch('grid/addDownloadNotification', notification)

      window.Echo.private(`facial-recognition-export-${jobId}`)
        .listen(".process", (data) => {
          const notification = {
            id: `facial-recognition-export-${jobId}`,
            progress: data.progress,
            completed: false,
            view: 'facial-recognition',
            url: '',
            title: 'Reporte de reconocimiento facial',
            body: 'Descargando...',
            error: false,
            timestamp: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
          }
          store.dispatch('grid/updateDownloadNotification', notification)
          state.progress = data.progress
        })
        .listen(".end", (data) => {
          const notification = {
            id: `facial-recognition-export-${jobId}`,
            progress: 100,
            completed: true,
            view: 'facial-recognition',
            url: data.url,
            title: 'Reporte de reconocimiento facial',
            body: 'Descarga completa',
            error: false,
            timestamp: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
          }
          store.dispatch('grid/updateDownloadNotification', notification)
          window.Echo.leave(`facial-recognition-export-${jobId}`)

          state.url = data.url
        })
        .listen(".exception", (data) => {
          const notification = {
            id: `facial-recognition-export-${jobId}`,
            progress: 100,
            completed: true,
            view: 'facial-recognition',
            url: data.url,
            title: 'Reporte de reconocimiento facial',
            body: 'Ocurrio un error',
            error: true,
            timestamp: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
          }
          store.dispatch('grid/updateDownloadNotification', notification)
          window.Echo.leave(`facial-recognition-export-${jobId}`)
          state.error = 'Ocurrio un error'
        })
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
